export const SUCCESS = 0;
export const SYSTEM_INTERNAL_ERROR = 1;
export const CONNECT_TIMEOUT = 2;
export const INVALID_IP = 3;
export const INVALID_REQUEST = 4;
export const INVALID_TOKEN = 5;
export const NO_AUTHORIZATION = 6;
export const GATEWAY_ERROR = 7;
export const INVALID_CODE = 1001;
export const USER_NOT_EXIST = 1002;
export const PARAMETER_ERROR = 2001;
